import React, { Component } from 'react';
import { connect } from 'react-redux';
import { FaCheck, FaTimes, FaMusic } from 'react-icons/fa';
import Select, { components } from 'react-select';
import Swal from 'sweetalert2';

import { editSound } from 'redux/actions';
import Paths from 'paths';
import customStyles from 'consts/CustomStyles';
import { configure, HotKeys } from 'react-hotkeys';

configure({
    ignoreEventsCondition: (event) => { return false; }
});

class SoundEdit extends Component {

    state = {
        submit_redirection: false
    }

    constructor(props) {
        super(props);
    
        this.keyMap = {
            VALIDATE_AND_EDIT_NEXT: { sequence: 'Shift+Enter' },
            VALIDATE_AND_EDIT_PREVIOUS: { sequence: 'Control+Shift+Enter' },
            PLAY_SOUND: { sequence: 'Control+=' }
        };
    
        this.handlers = {
            VALIDATE_AND_EDIT_NEXT: () => this.submitAndEditSibling(1),
            VALIDATE_AND_EDIT_PREVIOUS: () => this.submitAndEditSibling(-1),
            PLAY_SOUND: () => this.clickPlaySound()
        };
    }

    componentDidMount() {
        this.title.focus(); 
    }

    submitAndEditSibling = (value) => {
        console.log("AVANT ?");
        for(let i=0; i<this.props.soundbox.sounds.length; i++) {
            if(this.props.soundbox.sounds[i].id === this.props.sound.id && this.props.soundbox.sounds[i+value] !== undefined) {
                this.setState({
                    submit_redirection: Paths.PATH_ADMIN_EDIT_SOUND
                                            .replace(':soundboxId', this.props.soundbox.id)
                                            .replace(':soundId', this.props.soundbox.sounds[i+value].id)
                });
                break;
            }
        }
    }

    handleSubmit = (e) => {
        console.log("APRES ?");
        e.preventDefault();
        this.props.editSound(
            this.props.soundbox.id,
            this.props.sound.id,
            {
                id: +this.id.value,
                characters: this.refs.characters.state.value ? this.refs.characters.state.value.map(char => char.value) : [],
                movie: this.refs.movie.state.value.value,
                title: this.title.value,
                titleFiltered: this.title.value,
                timing: this.timing.value,
                quote: this.quote.value,
                quoteFiltered: this.quote.value
            }
        );
        let redirection;
        if(this.state.submit_redirection) {
            redirection = this.state.submit_redirection;
            this.setState({ submit_redirection: false });
        } else {
            redirection = Paths.PATH_ADMIN_SHOW_SOUNDBOX.replace(':soundboxId', this.props.soundbox.id);
        }
        this.props.history.push(redirection);
    }

    cancel = (e) => {
        this.props.history.push(Paths.PATH_ADMIN_SHOW_SOUNDBOX.replace(':soundboxId', this.props.soundbox.id));
    }
    
    render() {
        let characterList = [], characterDefault = [];
        for(let i=0; i<this.props.soundbox.characters.length; i++) {
            let character = this.props.soundbox.characters[i],
                json = { value: character.id, label: character.id+": "+character.name };
            characterList.push(json);
            if(this.props.sound.characters.indexOf(character.id) !== -1) { characterDefault.push(json); }
        }

        let movieList = [], movieDefault = null;
        for(let i=0; i<this.props.soundbox.movies.length; i++) {
            let movie = this.props.soundbox.movies[i],
                json = { value: movie.id, label: movie.id+": "+movie.title };
            movieList.push(json);
            if(this.props.sound.movie === movie.id) { movieDefault = json; }
        }

        return (
            <HotKeys keyMap={this.keyMap} handlers={this.handlers}>
                <form onSubmit={(e) => this.handleSubmit(e)} className={'soundbox-grid-sound'}>
                    <div className={'soundbox-grid-sound-id'}>
                        <input type="number" name="form-id" placeholder="ID" required defaultValue={this.props.sound.id} ref={input => this.id = input} />
                    </div>
                    <div className={'soundbox-grid-sound-characters'}> 
                        <Select 
                            ref={'characters'} 
                            isMulti
                            defaultValue={characterDefault}
                            options={characterList} 
                            styles={customStyles.chars}
                            placeholder={'Chars'}
                            components={{ 
                                MultiValueLabel:({ ...props }) => { return (<components.MultiValueLabel {...props}>{props.data.value}</components.MultiValueLabel>)},
                                IndicatorsContainer:() => { return null }
                            }}>
                        </Select>
                    </div>
                    <div className={'soundbox-grid-sound-movie'}>
                        <Select 
                            ref={'movie'} 
                            options={movieList} 
                            defaultValue={movieDefault}
                            styles={customStyles.movies}
                            placeholder={'Film'}
                            components={{ 
                                SingleValue:({ ...props }) => { return <components.SingleValue {...props}>{props.getValue()[0].value}</components.SingleValue>},
                                IndicatorsContainer:() => { return null }
                            }}
                            required>
                        </Select>
                    </div>
                    <div className={'soundbox-grid-sound-title'}>
                        <input type="text" name="form-title" placeholder="Titre" required defaultValue={this.props.sound.title} ref={input => this.title = input} />
                    </div>
                    <div className={'soundbox-grid-sound-timing'}>
                        <input type="text" name="form-timing" placeholder="Temps" defaultValue={this.props.sound.timing} ref={input => this.timing = input} />
                    </div>
                    <div className={'soundbox-grid-sound-play'} onClick={this.clickPlaySound}><FaMusic/></div>
                    <div className={'soundbox-grid-sound-quote'}>
                        <textarea ref={input => this.quote = input} placeholder="Réplique" defaultValue={this.props.sound.quote} ></textarea>
                    </div>
                    <button type="submit" className={'soundbox-grid-sound-save'}>
                        <FaCheck />
                    </button>
                    <div className={'soundbox-grid-sound-cancel'} onClick={this.cancel}>
                        <FaTimes />
                    </div>
                </form>
            </HotKeys>
        )
    }

    clickPlaySound = () => {
        console.log(this.props);
        if(this.props.soundUrl === undefined) {
            Swal.fire({
                title: 'Son manquant ?',
                text: `Ce son n'a pas été trouvé !`,
                icon: 'error',
                confirmButtonText: 'Ok'
            });
        } else {
            try {
                let audio = new Audio(this.props.soundUrl.url);
                audio.play();
            } catch(e) {
                console.log(e);
            };
        }
    }
}

const mapDispatchToProps = (dispatch) => {
    return {
        editSound: (soundbox, oldId, item) => {
            dispatch(editSound(soundbox, oldId, item))
        }
    }
}

export default connect(null, mapDispatchToProps)(SoundEdit);